import { createBrowserRouter } from "react-router-dom";

// let routes = require(process.env.REACT_APP_ROUTES_PATH === "SUPPORT" ? "./routerPMT" : "./routerSupport").default;

let isSupport =
    process.env.REACT_APP_APP_TYPE === "SUPPORT";

let routes = isSupport
    ? require("./routerSupport").default
    : require("./routerPMT").default;

console.log("APP TYPE:", process.env.REACT_APP_APP_TYPE);

const router = createBrowserRouter(routes ?? [], {
    basename: isSupport ? "/support" : "/",
});

export default router